import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit"; // 리듀서 결합을 위해 추가


import appReducer from './redux';


// ✅ reduxIgong 슬라이스만 별도 persist 설정
const igongPersistConfig = {
    key: 'appReducer',
    storage,
    blacklist: ['isLoggedIn', 'userName',
        'selectedUserInfo_stu', 'selectedUserInfo_tec', 'selectedUserInfo_st',
        'selectedUserInfo_acaMom', 'selectedUserInfo_st_chart'], // 이 두 필드는 저장되지 않음
};

// 🔧 reduxIgong만 별도로 persistReducer 적용
const persistedAppReducer = persistReducer(igongPersistConfig, appReducer);

// 🔧 전체 persist 설정 (루트 레벨에서는 reduxIgong을 그대로 포함)
const persistConfig = {
    key: "root",
    storage,
    blacklist: [], // reduxIgong은 포함시킴 (별도 persist 설정이 적용됨)
};

// combineReducers로 리듀서 결합
const rootReducer = combineReducers({
    appReducer: persistedAppReducer,
});


// Persist Reducer 생성
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Redux Store 생성
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Redux Persist의 액션을 무시하도록 설정
                ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
            },
        }),
});


// Persistor 생성
export const persistor = persistStore(store);
